import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FunctionsService } from 'src/app/services/functions.service';
import { Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';
import * as XLSX from 'xlsx';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';

@Component({
  selector: 'app-export-alert-chat-log',
  templateUrl: './export-alert-chat-log.component.html',
  styleUrls: ['./export-alert-chat-log.component.css'],
  providers: [ NgxSpinnerService]
})

export class ExportAlertChatLogComponent implements OnInit {
  @Input() alertId: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    public functionsService: FunctionsService,
    private apiService: ApiService,
    private dateAdapter: DateAdapter<Date>,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private angularFireStore: AngularFirestore,
    private modalService: NgbModal) {}

  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  minDate: Date;
  maxDate: Date;
  hourRange: any;
  chatMessages: Array<any> = [];

  location: boolean = true;
  formSubmitted: boolean = false;
  exportLogForm = this.formBuilder.group({
    date: new UntypedFormControl('')
  });

  ngOnInit() {
    this.dateAdapter.setLocale(this.language); 
    this.hourRange = AppConstants.hourRange;
    this.maxDate = new Date(); 
    this.getAlertDate();
  }
  
  exportData() {
    if (!this.exportLogForm.valid) {
      this.formSubmitted = true;
      return;
    } 
    this.spinner.show();
    this.exportLogForm.value["timeZone"] = (-1)*(new Date().getTimezoneOffset()/60);
    this.exportLogForm.value["alertId"] = this.alertId;
    this.exportLogForm.value["location"] = this.location;
    this.exportLogForm.value["chatHistory"] = true;
    this.exportLogForm.value['hours'] = "00:00:00-23:59:59";
    var hoursSelected = this.exportLogForm.value['hours'].split('-');
    if(this.exportLogForm.value['date']){
      var d = this.exportLogForm.value['date'].toString().split(' ');
      d[1] = this.exportLogForm.value['date'].getMonth()+1 < 10 ? "0" + (this.exportLogForm.value['date'].getMonth()+1).toString():  this.exportLogForm.value['date'].getMonth()+1;
      var startDate = new Date(`${d[3]}-${d[1]}-${d[2]}T${hoursSelected[0]}`);
      var endDate = new Date(`${d[3]}-${d[1]}-${d[2]}T${hoursSelected[1]}`);
    }else{
      var min = this.minDate.toString().split(' ');
      min[1] = this.minDate.getMonth()+1 < 10 ? "0" + (this.minDate.getMonth()+1).toString():  (this.minDate.getMonth()+1).toString();
      var max = this.maxDate.toString().split(' ');
      max[1] = this.maxDate.getMonth()+1 < 10 ? "0" + (this.maxDate.getMonth()+1).toString():  (this.maxDate.getMonth()+1).toString();
      var startDate = new Date(`${min[3]}-${min[1]}-${min[2]}T${hoursSelected[0]}`);
      var endDate = new Date(`${max[3]}-${max[1]}-${max[2]}T${hoursSelected[1]}`);
    }
    this.apiService.alertLogExport(this.exportLogForm.value).subscribe(
      data => {
        var userId = data["alert"]["createdBy"];
        var user = data["alert"]["createdByName"];
        var agentId = data["alert"]["attendedBy"];
        var agent = data["alert"]["attendedByName"];
        var name ="";
        var dataArray = [];
        var logs = [];
        let messages$ = this.angularFireStore
        .collection<firebase.default.firestore.DocumentData>(`${environment.firebaseConfig.path}/${this.alertId}/Messages`).valueChanges();
        messages$.pipe(
            map(chat => {
              for (var i = chat.length - 1; i >= 0; i --){
                chat[i].timestamp = chat[i].timestamp * 1000;
                if(chat[i].contentType == 3 || (chat[i].timestamp < startDate.getTime() || chat[i].timestamp > endDate.getTime())){
                  chat.splice(i, 1);
                }
              }
              return chat.sort((a, b) => (a.timestamp > b.timestamp) ? 1 : -1);
            })
        ).subscribe(chat => {
          this.chatMessages = chat;
          let jsonString = JSON.stringify(data);
          let jsonObject = JSON.parse(jsonString);
          var i = 0;
          var j = 0;
          var k = 0;
          var splitLocation;
          var chat1 = this.chatMessages.reverse();
          while((i<jsonObject["alertLog"].length) || (j<chat1.length)){
            if(jsonObject["alertLog"][i] && chat1[j]){
              var newDate = new Date(jsonObject["alertLog"][i].eventDate+"Z");
              var messageDate = new Date(chat1[j]["timestamp"]);
              if(newDate.getTime()>messageDate.getTime()){
                  logs[k] = [];
                if(jsonObject["alertLog"][i].name == "video_available"){
                  var params = (jsonObject["alertLog"][i].description.split(","));
                  logs[k][1] = this.translate.instant("alert_activity_export.video_available", {value: params[1] + "s"});

                  logs[k][0] = this.functionsService.convertUTCDateToLocalDateMessage(jsonObject["alertLog"][i].eventDate+"Z");
                    if(this.language == "es"){
                      dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                    }else{
                      dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                    }
                }
                i++;
              }else {
                  logs[k] = [];
                name = (chat1[j]["ownerID"]==userId)?user:((chat1[j]["ownerID"]==agentId)?agent:"Rep. #"+chat1[j]["ownerID"]);
                switch(chat1[j]["contentType"]){
                  case 1:
                    logs[k][1] = this.translate.instant("alert_activity_export.image_shared", {name: name});
                    break;
                  case 2:
                    splitLocation = (chat1[j]["content"]).toString().split(',');
                    logs[k][1] = this.translate.instant("alert_activity_export.location_shared", {lat: parseFloat(splitLocation[0]), lng: parseFloat(splitLocation[1])});
                    break;
                  default:
                    logs[k][1] = this.translate.instant("alert_activity_export.message_sent", {name: name, value: chat1[j]["message"]});
                }
                
                logs[k][0] = this.functionsService.convertUTCDateToLocalDateMessage(chat1[j]["timestamp"]);
                    if(this.language == "es"){
                      dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                    }else{
                      dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                    }
                j++;
              }
              k++;
            }
            else if(jsonObject["alertLog"][i]){
              logs[k] = [];
              if(jsonObject["alertLog"][i].name == "video_available"){
                var params = (jsonObject["alertLog"][i].description.split(","));
                logs[k][1] = this.translate.instant("alert_activity_export.video_available", {value: params[1] + "s"});

                logs[k][0] = this.functionsService.convertUTCDateToLocalDateMessage(jsonObject["alertLog"][i].eventDate+"Z");
                    if(this.language == "es"){
                      dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                    }else{
                      dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                    }
              }
              i++;
              k++;
            }
            else if(chat1[j]){
                logs[k] = [];
              name = (chat1[j]["ownerID"]==userId)?user:((chat1[j]["ownerID"]==agentId)?agent:"Rep. #"+chat1[j]["ownerID"]);
              switch(chat1[j]["contentType"]){
                case 1:
                  logs[k][1] = this.translate.instant("alert_activity_export.image_shared", {name: name});
                  break;
                case 2:
                  splitLocation = (chat1[j]["content"]).toString().split(',');
                  logs[k][1] = this.translate.instant("alert_activity_export.location_shared", {lat: parseFloat(splitLocation[0]), lng: parseFloat(splitLocation[1])});
                  break;
                default:
                  logs[k][1] = this.translate.instant("alert_activity_export.message_sent", {name: name, value: chat1[j]["message"]});
              }
              
                logs[k][0] = this.functionsService.convertUTCDateToLocalDateMessage(chat1[j]["timestamp"]);
                  if(this.language == "es"){
                    dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                  }else{
                    dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                  }
              j++;
              k++;
            }
          }
          if(dataArray.length > 0){
            const fileName = `SA-Chat-${this.alertId}.csv`;
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataArray);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'SA');
            XLSX.writeFile(wb, fileName);
          }
          else{
              const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
              modalRef.componentInstance.title = "Error";
              modalRef.componentInstance.message = this.translate.instant('general.no_data_avail_date');
          }
          this.spinner.hide();
          this.activeModal.close();
        });
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  getAlertDate(){
    this.spinner.show();
    this.apiService.alertStartDate(this.alertId).subscribe(
        data => {
            this.minDate = new Date(data["createdDate"].toString());
            this.maxDate = new Date(data["closedDate"].toString());
            this.spinner.hide();
        },
        error => {
            this.minDate = new Date();
            this.maxDate = new Date();
            this.spinner.hide();
        }
    );
  }

  get date() { return this.controlGetter('date'); }
  get hours() { return this.controlGetter('hours'); }

  controlGetter(controlName) {
    const control =  this.exportLogForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }

  selectLocations(locationSetting: boolean){
      this.location = locationSetting;
      if(!this.location){
        this.exportLogForm.setControl('hours', new UntypedFormControl(''))
      }
      else{
        this.exportLogForm.setControl('hours', new UntypedFormControl('', Validators.compose([Validators.required])));
      }
  }
}